import { call, put, takeLatest } from 'redux-saga/effects';

import { adminActions as actions } from '.';
import { AdminAction, Response } from './types';
import { request } from '../../../helpers/request';
import { API } from './constants';

export function* getCurrentUserGenerator() {
  try {
    const response: Response = yield call(request, API.GET_CURRENT_USER, {}, true);
    if (response.success) {
      yield put(actions.getCurrentUserSucceeded(response.data));
    } else {
      yield put(actions.getCurrentUserFailed());
    }
  } catch (err) {
    yield put(actions.getCurrentUserFailed());
  }
}

export function* logoutGenerator({ payload: data }: AdminAction) {
  try {
    const response: Response = yield call(request, API.LOGOUT, {}, true);
    if (response.success) {
      yield put(actions.logoutSucceeded());
      localStorage.removeItem(`token-${process.env.REACT_APP_PUBLIC_URL}`);
      localStorage.removeItem(`refresh-token-${process.env.REACT_APP_PUBLIC_URL}`);
      window.location.href = '/';
    } else {
      yield put(actions.logoutFailed());
    }
  } catch (err) {
    yield put(actions.logoutFailed());
  }
}

export function* getSessionTimelineGenerator({ payload: sessionId }: AdminAction) {
  try {
    const response: Response = yield call(request, API.GET_SESSION_TIMELINE, { id: sessionId }, true);
    if (response.success) {
      yield put(actions.getSessionTimelineSucceeded(response.data));
    } else {
      yield put(actions.getSessionTimelineFailed());
    }
  } catch (err) {
    yield put(actions.getSessionTimelineFailed());
  }
}

export function* getUserSessionsGenerator({ payload: data }: AdminAction) {
  try {
    const response: Response = yield call(request, API.GET_CHAT_SESSIONS, data, true);
    if (response.success) {
      yield put(actions.getUserSessionsSucceeded(response.data));
    } else {
      yield put(actions.getUserSessionsFailed());
    }
  } catch (err) {
    yield put(actions.getUserSessionsFailed());
  }
}



export function* adminSaga() {
  yield takeLatest(actions.getCurrentUser.type, getCurrentUserGenerator);
  yield takeLatest(actions.logout.type, logoutGenerator);
  yield takeLatest(actions.getSessionTimeline.type, getSessionTimelineGenerator);
  yield takeLatest(actions.getUserSessions.type, getUserSessionsGenerator);
}
export default adminSaga;
